// extracted by mini-css-extract-plugin
export var link = "_sr-0";